interface CloudinaryImage {
    cloudinaryUrl: string;
    smallCloudinaryUrl: string;
    mobileCloudinaryUrl: string;
}

export function buildSrcset(imageData: CloudinaryImage): string {
    const { cloudinaryUrl, smallCloudinaryUrl, mobileCloudinaryUrl } = imageData;

    const srcset = [
        `${smallCloudinaryUrl} 178w`,
        `${mobileCloudinaryUrl} 480w`,
        `${cloudinaryUrl} 1200w`,
    ].join(', ');

    return srcset;
}
